
import SVGProductCard from "./components/SvgProductCard"

const NewVersionPage = () => {
   return (
      <>
         <div className="w-full min-h-screen bg-orange-50 flex justify-center items-center">
            {/* <CurvyCard /> */}
            {/* <MaskedCurvyCard /> */}
            <SVGProductCard />
         </div>
      </>
   )
}

export default NewVersionPage
